import _extends from "../../../@babel/runtime/helpers/esm/extends.js";
function resolveProps(defaultProps, props) {
  const output = _extends({}, props);
  return Object.keys(defaultProps).forEach((propName) => {
    if (propName.toString().match(/^(components|slots)$/))
      output[propName] = _extends({}, defaultProps[propName], output[propName]);
    else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {}, slotProps = props[propName];
      output[propName] = {}, !slotProps || !Object.keys(slotProps) ? output[propName] = defaultSlotProps : !defaultSlotProps || !Object.keys(defaultSlotProps) ? output[propName] = slotProps : (output[propName] = _extends({}, slotProps), Object.keys(defaultSlotProps).forEach((slotPropName) => {
        output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
      }));
    } else output[propName] === void 0 && (output[propName] = defaultProps[propName]);
  }), output;
}
export {
  resolveProps as default
};
//# sourceMappingURL=resolveProps.js.map
